import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2, Camera, Images } from 'lucide-react';

export const GalleryModal = ({
  galleryOpen,
  setGalleryOpen,
  galleryImages,
  galleryLoading,
  galleryLocation,
}) => {
  return (
    <Dialog open={galleryOpen} onOpenChange={setGalleryOpen}>
      <DialogContent className="sm:max-w-3xl bg-white/95 backdrop-blur-xl max-h-[90vh] overflow-y-auto" data-testid="gallery-modal">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl flex items-center gap-2 text-ocean">
            <Images className="w-5 h-5 text-gold" />
            {galleryLocation}
          </DialogTitle>
          <DialogDescription>
            Explore photos of this location
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          {galleryLoading ? (
            <div className="flex flex-col items-center justify-center py-12" data-testid="gallery-loading">
              <Loader2 className="w-10 h-10 text-ocean animate-spin mb-4" />
              <p className="text-charcoal/60">Loading photos...</p>
            </div>
          ) : galleryImages.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-testid="gallery-grid">
              {galleryImages.map((img, idx) => (
                <div
                  key={`gallery-thumb-${idx}`}
                  className="relative group overflow-hidden rounded-xl shadow-md aspect-[4/3] bg-gray-100"
                  data-testid={`gallery-modal-image-${idx}`}
                >
                  <img
                    src={img.url}
                    alt={img.title || galleryLocation}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  {img.title && (
                    <p className="absolute bottom-2 left-2 right-2 text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 truncate drop-shadow-lg">
                      {img.title}
                    </p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12" data-testid="gallery-empty">
              <Camera className="w-10 h-10 text-charcoal/30 mx-auto mb-3" />
              <p className="text-charcoal/60">No photos found for this location</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
